import { computed, watch, ref, toValue } from 'vue'
import { toCamelCase } from '@/utils/utils'
import Query from '@/classes/queries/Query'
import { get as _get, cloneDeep as _cloneDeep } from 'lodash'

export default function gettersStore ({ store }) {
  store.$getItems = ({ resource, query, reload = false, dependencies = [], multi_currency = false, fetch }) => {
    const key = computed(() => new Query({ query: { ...toValue(query), currency: multi_currency ? store.$currency : null }, default_value: 'default' }).to_string)
    const items = computed(() => _get(store.$state, `${resource}.['${key.value}'].items`, []))
    const pagination = computed(() => _get(store.$state, `${resource}.['${key.value}'].pagination`, {}))
    const status = computed(() => _get(store.$state, `${resource}.['${key.value}'].status`))
    const success = computed(() => status.value === 'success')
    const loader = computed(() => status.value === 'processing')
    const error = computed(() => _get(store.$state, `${resource}.['${key.value}'].error`, null))
    const hasDependencies = computed(() => dependencies.map(dependency => !!toValue(dependency)).every(item => toValue(item)))
    const isFetchRequired = computed(() => !status.value || reload)

    watch([key, hasDependencies], () => {
      if (hasDependencies.value && isFetchRequired.value && fetch) fetch()
    }, { immediate: true })

    return {
      [toCamelCase(resource)]: items,
      pagination,
      loader,
      error,
      success
    }
  }

  store.$getItem = ({ resource, key, reload = false, dependencies = [], multi_currency = false, fetch }) => {
    const path = computed(() => toValue(key) ? `${resource}.['${toValue(key)}']` : resource)
    const item = computed(() => _get(store.$state, `${path.value}.item`, null))
    const status = computed(() => _get(store.$state, `${path.value}.status`))
    const success = computed(() => status.value === 'success')
    const loader = computed(() => status.value === 'processing')
    const error = computed(() => _get(store.$state, `${path.value}.error`, null))
    const currency = computed(() => _get(store.$state, `${path.value}.currency`))
    const hasDependencies = computed(() => dependencies.every(dependency => !!toValue(dependency)))
    const isFetchRequired = computed(() => !status.value || reload || (multi_currency && (currency.value !== store.$currency)))

    const cloned_item = ref(_cloneDeep(item.value))

    watch(item, item => cloned_item.value = _cloneDeep(item))
    watch([path, hasDependencies, isFetchRequired], () => {
      if (hasDependencies.value && isFetchRequired.value && fetch) fetch()
    }, { immediate: true })

    return {
      [toCamelCase(resource)]: item,
      [toCamelCase(`cloned_${resource}`)]: cloned_item,
      loader,
      error,
      status,
      success
    }
  }

  store.$getItemFromState = key => _get(store.$state, `${key}.item`, null)
}